import { makeStyles } from '@mui/styles';
import { useDataStoreBusy } from 'components/DataStoreReference/DataStoreReference';
import WaveDots from '../../../utils/WaveDots';

const useStyles = makeStyles(() => ({
  root: {
    alignItems: 'center',
    bottom: 0,
    display: 'flex',
    height: 20,
    justifyContent: 'center',
    pointerEvents: 'none',
    position: 'absolute',
    right: 0,
    width: 30,
    zIndex: 1,
  },
}));

export default function GridLoadingIndicator({
  pending,
}: {
  pending: boolean;
}) {
  const classes = useStyles();
  const busy = useDataStoreBusy();
  if (!(pending || busy)) {
    return null;
  }
  return (
    <div data-testid="scrolling-ind" className={classes.root}>
      <WaveDots active />
    </div>
  );
}
